import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  auth,
  signInWithEmailAndPassword,
  setPersistence,
  browserSessionPersistence
} from "../../firebase";
import LoadingSpinner from "../../components/LoadingSpinner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const handle = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);

    try {
      // Set session persistence to expire when browser tab closes
      await setPersistence(auth, browserSessionPersistence);
      const cred = await signInWithEmailAndPassword(auth, email, password);
      console.log("User logged in:", cred.user.email);
      nav("/loading");
    } catch (error) {
      console.error("Login error:", error);
      let message = "Login failed";
      if (error?.code) {
        switch (error.code) {
          case "auth/user-not-found":
            message = "No user found with that email.";
            break;
          case "auth/wrong-password":
            message = "Incorrect password.";
            break;
          case "auth/invalid-email":
            message = "Invalid email address.";
            break;
          case "auth/user-disabled":
            message = "This user account has been disabled.";
            break;
          default:
            message = error.message || "Login failed. Please try again.";
        }
      }
      setErr(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <form className="login-box" onSubmit={handle}>
          <img
            src="/assets/Smart Systems Short Logo.png"
            alt="Smart Assistant Systems Logo"
            className="login-logo-img"
          />
          <h2>Fleet Assistant — Admin Login</h2>
          {err && <div className="error">{err}</div>}

          <label htmlFor="email">Email</label>
          <input
            id="email"
            className="login-label"
            type="email"
            placeholder="Enter your admin email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label htmlFor="password">Password</label>
          <input
            id="password"
            className="login-label"
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      )}
    </div>
  );
}